import AppState from '../reducers/app-state';
import Group, { sortGroupMembers } from '@repo/utils/models/Group';
import { selectGroupShareStatus } from '../reducers/data/shareStatuses/groups';
import { GroupViewState, ID } from '@repo/utils/types';
import { selectContact } from './contacts';

/* Selectors */
export const selectGroupView = (state: AppState): GroupViewState => {
  const { group: groupViewGroup, ...viewState } = state.ui.groupView;
  const getContact = (id: ID) => selectContact(id)(state);
  const group = groupViewGroup || new Group({});

  return {
    ...viewState,
    group: sortGroupMembers(group, getContact, group.sorting),
  };
};

export const selectActiveGroupView = (
  state: AppState,
): (GroupViewState & { isShared: boolean }) | null => {
  const groupInView = state.ui.location?.view?.startsWith('Group');

  if (!groupInView) {
    return null;
  }

  const groupViewState = state.ui.groupView;
  const groupShareStatus = selectGroupShareStatus(groupViewState.group?.id)(state);

  return { ...groupViewState, isShared: !!groupShareStatus?.isShared };
};

export const selectActiveGroup = (state: AppState): Group | null => {
  const groupInView = selectActiveGroupView(state);
  return groupInView ? groupInView.group : null;
};

/* Actions */
export const setGroupInView = (group: Group | null) => ({
  type: 'SET_GROUP_IN_VIEW',
  payload: { group },
});

export const updateGroupInView = (group: Group) => ({
  type: 'UPDATE_GROUP_IN_VIEW',
  payload: { group },
});

export const startEditing = { type: 'START_GROUP_EDITING' };
export const stopEditing = { type: 'STOP_GROUP_EDITING' };
export const startContactEditing = { type: 'START_GROUP_CONTACT_EDITING' };
export const stopContactEditing = { type: 'STOP_GROUP_CONTACT_EDITING' };
export const resetGroup = { type: 'RESET_GROUP_IN_VIEW' };
